/* src/pages/ITHealthCheck.js */

import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import PageSection from "../components/PageSection";
import styles from "./Pages.module.css";

function ITHealthCheck() {
  const faqs = [
    {
      question: "What happens after the health check?",
      answer: "You get a plain-English summary of what looks good, what is risky, and what I would fix first. No pressure to buy a monthly plan.",
    },
    {
      question: "Is this remote or onsite?",
      answer: "Most checks can start remotely. If something needs eyes or hands onsite in Shreveport/Bossier, we will talk through that before scheduling.",
    },
    {
      question: "Who is this for?",
      answer: "Small businesses that know their IT is messy but do not know where to start: slow computers, weak Wi-Fi, no backup confidence, or too many old accounts.",
    },
  ];

  return (
    <PageSection title="IT Health Check" cta faqs={faqs}>
      <Helmet>
        <title>$149 IT Health Check | Tharpe Industries</title>
        <meta
          name="description"
          content="A $149 IT Health Check for Shreveport-Bossier small businesses. Review computers, network, backups, and security with clear next steps."
        />
      </Helmet>
      <div className={`${styles.textContent} ${styles.healthCheckContent}`}>
        <div className={styles.healthHero}>
          <p className={styles.healthLead}>
            A focused check of computers, Wi-Fi, backups, accounts, and security risks.
          </p>
          <div className={styles.healthPriceBadge}>$149</div>
          <ul className={styles.healthQuickList}>
            <li>Spot downtime risks</li>
            <li>Check backup readiness</li>
            <li>Leave with a fix-now / fix-soon punch list</li>
          </ul>
          <Link to="/contact-us?source=it-health-check" className={styles.healthCTA}>Start the Health Check</Link>
        </div>

        <div className={styles.healthDetails}>
          <p><strong>What we review:</strong></p>
          <ul>
            <li>Computer age, performance, updates, and obvious risks</li>
            <li>Network/Wi-Fi reliability and basic router/firewall posture</li>
            <li>Backup setup and whether recovery is realistic</li>
            <li>Email/account security basics like MFA and old users</li>
            <li>Clear priority list: fix now, fix soon, watch later</li>
          </ul>
        </div>
      </div>
    </PageSection>
  );
}

export default ITHealthCheck;
